import { Alert } from 'antd'

export function BillBatchResult({ results }: { results: { billId: number; success: boolean; message?: string }[] }) {
  const failures = results.filter((item) => !item.success)
  const successCount = results.length - failures.length
  let type: 'success' | 'warning' | 'error' = 'error'
  if (failures.length === 0) {
    type = 'success'
  } else if (successCount > 0) {
    type = 'warning'
  }
  return (
    <Alert
      type={type}
      showIcon
      title={`成功 ${successCount} 张，失败 ${failures.length} 张`}
      description={
        failures.length > 0 ? (
          <div>
            {failures.map((item) => (
              <p key={item.billId}>
                #{item.billId}：{item.message ?? '操作失败'}
              </p>
            ))}
            <p>请关闭后重新选择失败账单操作。</p>
          </div>
        ) : undefined
      }
    />
  )
}
